export default __webpack_public_path__ + "static/media/pin-location-orange.d90ef48a.svg";